import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { WidgetMapRegion } from '../../../models/widget';
import { MapEditorInstance } from './map-editor.instance';


const OPTIONS = {
  regions: {},
  points: {}
}

let SVG = require('svg.js');
let SVGDraggable = require('svg.draggable.js');

@Component({
  selector: '[cw-map-region]',
  templateUrl: './region.component.html'
})

export class RegionComponent implements AfterViewInit, OnChanges {
  @Input() region: WidgetMapRegion;
  @Input() zoomLevel: number;
  @Input() isSelected: boolean;
  @Input() svg: any;
  @Output() changed: EventEmitter<WidgetMapRegion> = new EventEmitter<WidgetMapRegion>();
  @Output() selected: EventEmitter<WidgetMapRegion> = new EventEmitter<WidgetMapRegion>();

  pathElem: any;

  private dragStart: { x; y };
  private groupElem: any;
  private pathBbox: any;
  private textElem: any;

  constructor(private cd: ChangeDetectorRef, private instance: MapEditorInstance) {
  }

  ngAfterViewInit(): void {
    this.pathElem = SVG.select('.' + this.pathClassName);
    this.pathBbox = this.pathElem.bbox();
    this.groupElem = SVG.select('.' + this.className);
    this.textElem = SVG.select('.' + this.textClassName);

    this.instance.mouseClick.subscribe(e => {
      if (this.isSelected && e.shiftKey) {
        this.region.points.push({
          x: e.offsetX / this.zoomLevel,
          y: e.offsetY / this.zoomLevel,
        });
        this.changed.emit();
      }
    });

    this.textElem.on('click', (e) => {
      this.selected.emit(this.region);
    });

    /*this.pathElem.on('click', (e) => {
      this.selected.emit(this.region);
    });*/

    this.pathElem.draggable()
      .on('dragstart', (e) => {
        this.dragStart = { x: e.detail.p.x, y: e.detail.p.y };
      })
      .on('dragmove', (e) => {
        this.selected.emit(this.region);
        e.preventDefault();

        if (!e.detail.event.altKey) {
          return false;
        }

        let delta = {
          x: (e.detail.p.x - this.dragStart.x) / this.zoomLevel,
          y: (e.detail.p.y - this.dragStart.y) / this.zoomLevel
        };

        this.region.points.forEach(p => {
          p.x += (delta.x);
          p.y += (delta.y);
        });
        this.dragStart = { x: e.detail.p.x, y: e.detail.p.y };

        this.changed.emit();
      });
  }

  ngOnChanges() {
    if (this.pathElem) {
      this.pathBbox = this.pathElem.bbox();
    }
  }

  @HostListener('document:keyup', ['$event'])
  onKeyDown(e) {
    if (this.isSelected && e.altKey) {
      if (e.keyCode === 38) {
        this.movePointsY(-1);
      }
      else if (e.keyCode === 40) {
        this.movePointsY(1);
      }
      else if (e.keyCode === 37) {
        this.movePointsX(-1);
      }
      else if (e.keyCode === 39) {
        this.movePointsX(1);
      }
    }
  }


  onPointSelected(point) {
    this.selected.emit(this.region);
  }

  onPointDeleted(point, idx) {
    this.region.points.splice(idx, 1);
  }

  onPointMoved(point: { x, y }, idx: number) {
    this.region.points[idx].x = point.x;
    this.region.points[idx].y = point.y;
    this.changed.emit();
  }

  regionClick() {
    //this.selected = !this.selected;
  }

  get pathString() {
    if (!this.region.points.length) {
      return '';
    }

    let first = this.region.points[0], last = this.region.points[this.region.points.length - 1];

    let path: string = 'M' + (first.x * this.zoomLevel) + ',' + (first.y * this.zoomLevel);

    this.region.points.forEach(point => {
      path += 'L' + (point.x * this.zoomLevel) + ',' + (point.y * this.zoomLevel);
    });

    path += 'M' + first.x * this.zoomLevel + ',' + first.y * this.zoomLevel + 'L' + last.x * this.zoomLevel + ',' + last.y * this.zoomLevel;

    return path + 'Z';
  }

  get fillColor() {
    return this.isSelected ? '#0275d8' : '#000';
  }

  get strokeColor() {
    return '#000';
  }

  get strokeWidth() {
    return 1;
  }

  get opacity() {
    return this.isSelected ? '0.5' : '0.3';
  }

  get pathClassName() {
    return 'r_path_' + this.region.id;
  }

  get textClassName() {
    return 'r_text_' + this.region.id;
  }

  get textX() {
    const box = this.pathElem ? this.pathElem.bbox() : null;
    return box ? Math.floor(box.x + box.width / 2.0) : null;
  }

  get textY() {
    const box = this.pathElem ? this.pathElem.bbox() : null;
    return box ? Math.floor(box.y + box.height / 2.0) : null;
  }

  @HostBinding('attr.class')
  get className() {
    return 'r_' + this.region.id;
  }

  @HostBinding('attr.z-index')
  get zIndex() {
    return this.isSelected ? 100 : 1;
  }

  get textString() {
    if (this.region.entity) {
      return this.region.entity.text()
    }

    return '?';
  }

  private movePointsY(offset: number) {
    this.region.points.forEach(p => {
      p.y += offset;
    });
  }

  private movePointsX(offset: number) {
    this.region.points.forEach(p => {
      p.x += offset;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/map-editor/region.component.ts